import React from 'react';

//components
import Icon from '../icons/Icons';
import { ExternalLoginIcon, ExternalLoginUserImage, UserProfileImages } from 'thrive-components';

//interfaces
import { IconLibrary } from  '@/interfaces/IconLibrary';
import { IContentAudienceModalProfilePics } from  '@/interfaces/ContentAudienceModal';



const ContentAudienceModalProfilePics = ({name, profilePics, cap, type, hasNoUsers, isExternallyManaged, externalLoginIconUrl}: IContentAudienceModalProfilePics) => (
    <div className='profile-image-container'>
        <div className={`profile-image-wrapper ${type}`}>
            {hasNoUsers
                ?   <Icon 
                        iconName={IconLibrary.USER_NONE} 
                        sizeInPx={'14'} 
                    />

                :   (isExternallyManaged && cap === 1)
                        ?   <ExternalLoginUserImage 
                                profileImageUrl={profilePics[0]} 
                                providerIconUrl={externalLoginIconUrl} 
                            />

                        :   <UserProfileImages 
                                imageUrl={profilePics} 
                                imageCap={cap}
                            />
            }
        </div>

        <div className='profile-name-wrapper'>
            <span className={`user-or-group-name ${type}`}>{name}</span>
            
            {hasNoUsers && <span className='no-users'>(No members)</span>}

            {(isExternallyManaged && cap > 1) &&
                <ExternalLoginIcon
                    iconUrl={externalLoginIconUrl}
                />
            }
        </div>
    </div>
);

export default ContentAudienceModalProfilePics;